import React from 'react';

import useHighlightedUrl from '@swf/sports/hooks/useHighlightedUrl';

import styles from './Menu.scss';
import DefaultLink from './components/DefaultLink/DefaultLink';
import IconLink from './components/IconLink/IconLink';
import { Variant } from './types';

const Menu: React.FC<React.PropsWithChildren> = ({ children }) => {
  const highlightedUrl = useHighlightedUrl(
    React.Children.map(
      children,
      (child) => (child as React.ReactElement<{ url: string }>).props.url
    ) || []
  );

  return (
    <ul className={styles.list}>
      {React.Children.map(children, (child: React.ReactNode) =>
        React.cloneElement(child as React.ReactElement<{ isActive: boolean }>, {
          isActive: !(child as React.ReactElement<{ exact: boolean }>).props.exact
            ? (child as React.ReactElement<{ url: string }>).props.url === highlightedUrl
            : undefined
        })
      )}
    </ul>
  );
};

export { IconLink, DefaultLink, Menu, Variant };
